import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { Avatar } from '@mui/material';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import tmsLogo from '../../assets/svg/NASC_logo.svg';

import PrimaryButton from 'components/ui/PrimaryButton';
import UserTextInput from 'components/UserInput/UInput';
import { FiMinimize } from 'react-icons/fi';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { useForgotPasswordMutation } from 'redux/reducers/user/dashboard/tms-auth';
import learnImage from '../../assets/images/auth-one-bg.jpg';
import loginBg from '../../assets/images/loginBg.png';
import { ConfigurationContext } from 'components/provider/OrginazationContext';
import { backendURL } from 'redux/reducers/settings';

const defaultValues = {
  password: '',
  conf_password: ''
};

const UserForgotPasswordComp: React.FC = (): JSX.Element => {
  const [tabValue, setTabValue] = React.useState('1');
  const { paramToken, uid } = useParams();
  console.log(paramToken, uid);

  const tabHandleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  const navigate = useNavigate();
  const { mutateAsync: initResetPass, isLoading, isSuccess } = useForgotPasswordMutation();

  const schema = Yup.object().shape({
    password: Yup.string()
      .required('Password is required')
      .min(6, 'Password must be longer than 6 characters'),
    conf_password: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match')
  });

  const { handleSubmit, control } = useForm({
    defaultValues: defaultValues
    // resolver: yupResolver(schema)
  });

  const [showPassword, setShowPassword] = React.useState<boolean>(false);
  const [showConFPassword, setShowConFPassword] = React.useState<boolean>(false);

  const handleTogglePasswordVisibilty = () => {
    setShowPassword(!showPassword);
  };

  const handleToggleConFPasswordVisibilty = () => {
    setShowConFPassword(!showConFPassword);
  };

  const tabs = ['1', '2', '3'];
  const tabPanels = [
    { text: 'Create Assignment, Courses and Training', tabValue: '1' },
    { text: 'Assign Coordinator and Evaluator to the routine', tabValue: '2' },
    {
      text: 'Add trainee, coordinator and evaluator in the system',
      tabValue: '3'
    }
  ];

  const { appConfig } = React.useContext(ConfigurationContext);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          marginTop: '30px',
          backgroundImage: `url(${backendURL + appConfig?.background_image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
        <Grid
          container
          justifyContent={'center'}
          alignItems={'center'}
          sx={{ borderRadius: 4, width: '70%', height: '500px' }}>
          <Grid item xs={12} sm={12} md={6} height="inherit" alignSelf="stretch">
            {' '}
            <Box style={{ height: '100%' }}>
              {' '}
              <TabContext value={tabValue}>
                <Paper
                  sx={{
                    backgroundImage: appConfig?.register_image
                      ? `url("${backendURL}${appConfig.register_image}")`
                      : `url(${loginBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100%'
                  }}>
                  <Box
                    style={{
                      height: '100%',
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      textAlign: 'center',
                      backgroundColor: ' hsla(206,99%,31%, 0.8)',
                      color: 'white'
                    }}>
                    {' '}
                    {tabPanels.map((val, index) => {
                      return (
                        <TabPanel
                          key={index}
                          value={val.tabValue}
                          sx={{
                            width: 'inherit',
                            marginTop: '250px',
                            fontSize: '15px'
                          }}>
                          <Typography>{val.text}</Typography>
                        </TabPanel>
                      );
                    })}
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      marginTop: '-50px'
                    }}>
                    <Tabs
                      sx={{
                        '& .css-pwgyx0-MuiButtonBase-root-MuiTab-root': {
                          minWidth: '0',
                          padding: '0'
                        },
                        color: 'white'
                      }}
                      TabIndicatorProps={{
                        style: {
                          display: 'none'
                        }
                      }}
                      value={tabValue}
                      onChange={tabHandleChange}
                      centered>
                      {tabs.map((val) => {
                        return (
                          <Tab
                            key={val}
                            icon={
                              <FiMinimize
                                fontSize="large"
                              // sx={{
                              //   color: tabValue == val ? 'white' : 'gray',
                              //   padding: '0px'
                              // }}
                              />
                            }
                            value={val}
                            disableRipple={true}
                          />
                        );
                      })}
                    </Tabs>
                  </Box>
                </Paper>
              </TabContext>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} height="inherit" alignSelf="stretch">
            <Stack
              sx={{
                backgroundColor: 'white',

                height: '100%',
                padding: 0,
                justifyContent: 'center'
              }}>
              <Stack direction="row" sx={{ justifyContent: 'center', alignItems: 'center', mb: 6 }}>
                <Avatar
                  alt="NASC"
                  src={backendURL + appConfig?.logo}
                  sx={{ width: 80, height: 80 }}
                />
                <Typography ml={3} color={'blue'} sx={{ fontWeight: 700, fontSize: 18 }}>
                  {appConfig?.title ?? ''}
                </Typography>
              </Stack>

              <form
                style={{ padding: '0px 20px' }}
                onSubmit={handleSubmit(async ({ password }) => {
                  try {
                    await initResetPass({
                      password,
                      token: paramToken as string,
                      uidb64: uid as string
                    });
                    navigate('/');
                  } catch (error) {
                    console.error(error);
                  }
                })}>
                <UserTextInput
                  control={control}
                  name="password"
                  label="Password"
                  type={showPassword ? 'text' : 'password'}
                  onIconClick={handleTogglePasswordVisibilty}
                  endIcon={showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                  autoComplete="current-password"
                />
                <UserTextInput
                  control={control}
                  name="conf_password"
                  label="Confirm Password"
                  type={showConFPassword ? 'text' : 'password'}
                  onIconClick={handleToggleConFPasswordVisibilty}
                  endIcon={showConFPassword ? <MdVisibility /> : <MdVisibilityOff />}
                  autoComplete="current-password"
                />

                <FormGroup>
                  <PrimaryButton type="submit" title={isLoading ? 'Loading...' : 'Submit'} />
                </FormGroup>
              </form>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default UserForgotPasswordComp;
